module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('canvas', {
    staticStyle: {
      "width": "100%",
      "display": "block"
    }
  }), _c('div', {
    staticClass: "annotationLayer"
  }), _c('resize-sensor', {
    on: {
      "resize": _vm.resize
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-093fae08","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-pdf/src/pdf.vue
// module id = 1171
// module chunks = 2